import SVGSize from "./SVGSize";
import * as SVGIcon from "./SVGIcon";

const SVGResolver = {
  ad: {
    props: SVGSize.l,
    Component: SVGIcon.Ad,
  },
  amazon: {
    props: SVGSize.s,
    Component: SVGIcon.Amazon,
  },
  balloons: {
    props: SVGSize.m,
    Component: SVGIcon.Balloons,
  },
  bell_empty: {
    props: SVGSize.l,
    Component: SVGIcon.BellEmpty,
  },
  bell_fill: {
    props: SVGSize.l,
    Component: SVGIcon.BellFill,
  },
  bookmark: {
    props: SVGSize.m,
    Component: SVGIcon.Ribbon,
  },
  bookmarkStar: {
    props: SVGSize.m,
    Component: SVGIcon.RibbonStar,
  },
  buyMeACoffee: {
    props: SVGSize.s,
    Component: SVGIcon.BuyMeACoffee,
  },
  caret_down: {
    props: SVGSize.xl,
    Component: SVGIcon.CaretDown,
  },
  checkbox_false: {
    props: SVGSize.l,
    Component: SVGIcon.CheckboxFalse,
  },
  checkbox_true: {
    props: SVGSize.l,
    Component: SVGIcon.CheckboxTrue,
  },
  checkmark: {
    props: SVGSize.m,
    Component: SVGIcon.Checkmark,
  },
  circle_check: {
    props: SVGSize.l,
    Component: SVGIcon.CircleCheck,
  },
  circle_minus: {
    props: SVGSize.l,
    Component: SVGIcon.CircleMinus,
  },
  close: {
    props: SVGSize.l,
    Component: SVGIcon.Close,
  },
  cog: {
    props: SVGSize.m,
    Component: SVGIcon.Cog,
  },
  copyright: {
    props: SVGSize.m,
    Component: SVGIcon.Copyright,
  },
  comment: {
    props: SVGSize.l,
    Component: SVGIcon.Wreath,
  },
  dark_mode: {
    props: SVGSize.l,
    Component: SVGIcon.Moon,
  },
  dollar: {
    props: SVGSize.l,
    Component: SVGIcon.Dollar,
  },
  dollar_box: {
    props: SVGSize.xl,
    Component: SVGIcon.DollarBox,
  },
  draft: {
    props: SVGSize.l,
    Component: SVGIcon.Draft,
  },
  ellipses: {
    props: SVGSize.l,
    Component: SVGIcon.Ellipses,
  },
  error: {
    props: SVGSize.l,
    Component: SVGIcon.ErrorSVG,
  },
  exclamation: {
    props: SVGSize.xl,
    Component: SVGIcon.Exclamation,
  },
  facebook: {
    props: SVGSize.s,
    Component: SVGIcon.Facebook,
  },
  fire: {
    props: SVGSize.l,
    Component: SVGIcon.Fire,
  },
  font: {
    props: SVGSize.l,
    Component: SVGIcon.FontFamily,
  },
  full_screen_close: {
    props: SVGSize.l,
    Component: SVGIcon.FullScreenClose,
  },
  full_screen_open: {
    props: SVGSize.l,
    Component: SVGIcon.FullScreenOpen,
  },
  github: {
    props: SVGSize.s,
    Component: SVGIcon.Github,
  },
  goodreads: {
    props: SVGSize.s,
    Component: SVGIcon.Goodreads,
  },
  hashtag: {
    props: SVGSize.l,
    Component: SVGIcon.Hashtag,
  },
  instagram: {
    props: SVGSize.s,
    Component: SVGIcon.Instagram,
  },
  koFi: {
    props: SVGSize.s,
    Component: SVGIcon.KoFi,
  },
  light_mode: {
    props: SVGSize.l,
    Component: SVGIcon.Sun,
  },
  like: {
    props: SVGSize.l,
    Component: SVGIcon.Ribbon2,
  },
  lock: {
    props: SVGSize.m,
    Component: SVGIcon.Lock,
  },
  login: {
    props: SVGSize.m,
    Component: SVGIcon.Login,
  },
  medium: {
    props: SVGSize.s,
    Component: SVGIcon.Medium,
  },
  megaphone: {
    props: SVGSize.l,
    Component: SVGIcon.Megaphone,
  },
  menu: {
    props: SVGSize.l,
    Component: SVGIcon.Menu,
  },
  mug: {
    props: SVGSize.l,
    Component: SVGIcon.Mug,
  },
  new_release: {
    props: SVGSize.l,
    Component: SVGIcon.NewRelease,
  },
  next_1: {
    props: SVGSize.l,
    Component: SVGIcon.Next,
  },
  patreon: {
    props: SVGSize.s,
    Component: SVGIcon.Patreon,
  },
  pinterest: {
    props: SVGSize.s,
    Component: SVGIcon.Pinterest,
  },
  previous_1: {
    props: SVGSize.l,
    Component: SVGIcon.Previous,
  },
  question_octagon: {
    props: SVGSize.l,
    Component: SVGIcon.QuestionOctagon,
  },
  reddit: {
    props: SVGSize.s,
    Component: SVGIcon.Reddit,
  },
  sad: {
    props: SVGSize.m,
    Component: SVGIcon.Sad,
  },
  save: {
    props: SVGSize.m,
    Component: SVGIcon.Save,
  },
  sitemap: {
    props: SVGSize.l,
    Component: SVGIcon.Sitemap,
  },
  skull: {
    props: SVGSize.m,
    Component: SVGIcon.Skull,
  },
  soundcloud: {
    props: SVGSize.s,
    Component: SVGIcon.SoundCloud,
  },
  spotify: {
    props: SVGSize.s,
    Component: SVGIcon.Spotify,
  },
  star2: {
    props: SVGSize.m,
    Component: SVGIcon.Star2,
  },
  status_bad: {
    props: SVGSize.l,
    Component: SVGIcon.StatusBad,
  },
  status_good: {
    props: SVGSize.l,
    Component: SVGIcon.StatusGood,
  },
  story: {
    props: SVGSize.l,
    Component: SVGIcon.Story,
  },
  toggle_off: {
    props: SVGSize.l,
    Component: SVGIcon.ToggleOff,
  },
  toggle_on: {
    props: SVGSize.l,
    Component: SVGIcon.ToggleOn,
  },
  tumblr: {
    props: SVGSize.s,
    Component: SVGIcon.Tumblr,
  },
  twitter: {
    props: SVGSize.s,
    Component: SVGIcon.Twitter,
  },
  user: {
    props: SVGSize.l,
    Component: SVGIcon.User,
  },
  users: {
    props: SVGSize.xl,
    Component: SVGIcon.Users,
  },
  verified_check: {
    props: SVGSize.l,
    Component: SVGIcon.VerifiedCheck,
  },
  verified_check2: {
    props: SVGSize.l,
    Component: SVGIcon.VerifiedCheck2,
  },
  youtube: {
    props: SVGSize.s,
    Component: SVGIcon.Youtube,
  },
};

export default SVGResolver;

// star: {
//   props: SVGSize.m,
//   Component: SVGIcon.Star,
// },
// trophy: {
//   props: SVGSize.m,
//   Component: SVGIcon.Trophy,
// },
